import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const PauseAltIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props}>
    <path d="M23 7v18h-3V7h3Zm-3-2a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-3Zm-8 2v18H9V7h3ZM9 5a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H9Z" />
  </BaseIcon>
);
